import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// OAuth returns at /. Wait until its one-use query is exchanged before routing.
// SSO restores the original URL with replaceState, so keep a service selection.
export default function AuthLanding() {
  const { loading } = useAuth();
  if (loading) return <p>Completing sign-in…</p>;
  const target = window.location.pathname === '/service-access'
    ? window.location.pathname + window.location.search
    : '/dashboard';
  return <Navigate to={target} replace />;
}
